var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalander(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 6.33325V9.33325H0V6.33325C0 4.30663 1.63987 2.66675 3.66675 2.66675H23C25.0266 2.66675 26.6667 4.30663 26.6667 6.33325Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 23.3333C12.6667 17.4519 17.4519 12.6667 23.3333 12.6667C24.4988 12.6667 25.6159 12.8613 26.6667 13.208V9.33325H0V21.6667C0 23.6934 1.63987 25.3333 3.66675 25.3333H12.8613C12.7373 24.6841 12.6667 24.0173 12.6667 23.3333Z",
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 6.66675C5.93069 6.66675 5.33325 6.06931 5.33325 5.33325V1.33325C5.33325 0.597438 5.93069 0 6.66675 0C7.40256 0 8 0.597438 8 1.33325V5.33325C8 6.06931 7.40256 6.66675 6.66675 6.66675ZM20 6.66675C19.2639 6.66675 18.6667 6.06931 18.6667 5.33325V1.33325C18.6667 0.597438 19.2639 0 20 0C20.7361 0 21.3333 0.597438 21.3333 1.33325V5.33325C21.3333 6.06931 20.7361 6.66675 20 6.66675Z",
    fill: "#607D8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 14.6668C18.5547 14.6668 14.6668 18.5547 14.6668 23.3333C14.6668 28.1121 18.5547 32 23.3333 32C28.1121 32 32 28.1121 32 23.3333C32 18.5547 28.1121 14.6668 23.3333 14.6668ZM27.3413 21.8733L23.0081 26.8733C22.7654 27.1533 22.4173 27.3186 22.0481 27.3333H22C21.8249 27.3333 21.6515 27.2988 21.4898 27.2318C21.3281 27.1648 21.1811 27.0665 21.0574 26.9426L18.7241 24.6094C18.2026 24.0879 18.2026 23.2454 18.7241 22.7241C19.2454 22.2026 20.0879 22.2026 20.6094 22.7241L21.9306 24.0454L25.3254 20.1279C25.8081 19.5706 26.6506 19.5134 27.2068 19.9934C27.7627 20.4746 27.8228 21.3174 27.3413 21.8733Z",
    fill: "#4CAF50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalander);
export default __webpack_public_path__ + "static/media/calander.e8ddf986410766a98801829b8440af73.svg";
export { ForwardRef as ReactComponent };